module.exports = __webpack_public_path__ + "img/information_ethical@2x.ce1f638.jpg";